// 3rd party
import * as React from 'react';

// Shared UI
import { useLocalization, LocalizedText } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';

// Components
import { WidgetCodeGuideLink } from 'components/shared/widget';

// Models
import { Product } from 'models';

interface WidgetCodeProps {
  children: React.ReactNode;
  product: Product;
  onLinkClick?: () => void;
}

const WidgetCode = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function WidgetCode(props: WidgetCodeProps): JSX.Element {
    const { children, product, ...otherProps } = props;

    const l10n = useLocalization();

    return (
      <section>
        <UitkHeading tag="h2" size={4}>
          <LocalizedText message="product.widget.code.title.get_the_code" />
        </UitkHeading>

        <UitkParagraph size={1}>
          <LocalizedText message="product.widget.code.instructions.to_embed_this_copy_code_read_guide" />
        </UitkParagraph>

        <UitkParagraph size={1}>
          <WidgetCodeGuideLink product={product} {...otherProps} />
        </UitkParagraph>

        <UitkSpacing margin={{ blockstart: 'four' }}>
          {/* Add product-specific WidgetCodeMarkup component/s */}
          {children}
        </UitkSpacing>
      </section>
    );
  },
);

export { WidgetCode };
